import {
  GET_PAX_ERR,
  GET_PAX_INNER_ERR,
  GET_PAX_INNER_REQ,
  GET_PAX_INNER_RES,
  GET_PAX_REQ,
  GET_PAX_RES,
  // ##### Komarov 2025-07-19
  SET_COUNTER_ADULTS,
  SET_COUNTER_CHILD,
  SET_COUNTER_ROOMS,
  SET_PAX_LIST_OPEN,
  SET_IS_ON_MODAL_DIV,
} from '../constants';

const initState = {
  pax: { adults: 1, children: 0, rooms: 1 },
  pax_loaded: true,
  errors: [],

  pax_inner_search: { adults: 1, children: 0, rooms: 1 },
  pax_inner_search_loaded: true,
  errors_inner_search: [],

  paxListOpen: false,
  isOnModalDiv: false
};

const reducer = (state = initState, action) => {
  // console.log('ACTION_pax', action)
  switch (action.type) {
    case GET_PAX_REQ:
      return {
        ...state,
        pax_loaded: true,
      };

    case GET_PAX_RES:
      return {
        ...state,
        pax_loaded: true,
        pax: action.payload,
      };

    case GET_PAX_ERR:
      return {
        ...state,
        //    ##### 23-09-01 Komarov
        errors: (state.errors && [...state.errors, action.error]) || [
          action.error,
        ],
      };

    case GET_PAX_INNER_REQ:
      return {
        ...state,
        pax_inner_search_loaded: true,
      };

    case GET_PAX_INNER_RES:
      return {
        ...state,
        pax_inner_search_loaded: true,
        pax_inner_search: action.payload,
      };

    case GET_PAX_INNER_ERR:
      return {
        ...state,
        //    ##### 23-09-01 Komarov
        errors_inner_search: (state.errors && [
          ...state.errors,
          action.error,
        ]) || [action.error],
      };

    // ##### Komarov 2025-07-19
    case SET_COUNTER_ADULTS:
      return { ...state, pax: { ...state.pax, adults: action.payload } };
    case SET_COUNTER_CHILD:
      return { ...state, pax: { ...state.pax, children: action.payload } };
    case SET_COUNTER_ROOMS:
      return { ...state, pax: { ...state.pax, rooms: action.payload } };
    case SET_PAX_LIST_OPEN:
      return { ...state, paxListOpen: action.payload };
    case SET_IS_ON_MODAL_DIV:
      return { ...state, isOnModalDiv: action.payload };

    default:
      return state;
  }
};

export default reducer;
